import { Package, Phone } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-obsidian text-stark">
      <div className="max-w-[1400px] mx-auto px-6 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <span className="bg-signal text-white p-1.5">
                <Package weight="bold" size={22} />
              </span>
              <span className="font-display font-semibold text-2xl tracking-tight">MAMA PARCEL</span>
            </div>
            <p className="font-sans text-neutral-400 max-w-md leading-relaxed">
              Domestic and international courier services engineered for speed, care and
              certainty. Every parcel, tracked door to door.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs tracking-widest text-signal mb-5 uppercase">Company</h4>
            <ul className="space-y-3 text-neutral-300 font-sans text-sm">
              <li><Link to="/track" className="hover:text-signal transition-colors">Track a Parcel</Link></li>
              <li><Link to="/login" className="hover:text-signal transition-colors">Admin Portal</Link></li>
              <li><a href="/#services" className="hover:text-signal transition-colors">Services</a></li>
              <li><a href="/#branches" className="hover:text-signal transition-colors">Branches</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs tracking-widest text-signal mb-5 uppercase">Contact</h4>
            <a href="tel:9154288291" className="flex items-center gap-2 font-mono text-lg hover:text-signal transition-colors">
              <Phone weight="bold" size={18} /> 91542 88291
            </a>
            <p className="text-neutral-400 text-sm mt-4 font-sans">Head Office<br />Gachibowli, Hyderabad, TS 500032</p>
          </div>
        </div>
        <div className="border-t border-neutral-800 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-neutral-500 text-xs font-mono tracking-wide">
          <span>© {new Date().getFullYear()} MAMA PARCEL LOGISTICS. ALL RIGHTS RESERVED.</span>
          <span>DOMESTIC · INTERNATIONAL · TRACKED</span>
        </div>
      </div>
    </footer>
  );
}
